// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { setMilliseconds as fn } from "../setMilliseconds.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const setMillisecondsWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default setMillisecondsWithOptions;
